/** @module SiteAdmin/CentricDrive/RestoreFileVersionController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/locale",
	"csi/action/Controller",
	"csi/action/FormData",
	"csi/comm/PostRequest",
	"csi/widget/MessageDialog",
	"csi/xml"

], function(declare,lang,locale,Controller,FormData,PostRequest,MessageDialog,xml) {

	return declare(Controller, {

		saveResourceId : "BUTTON_RESTORE",
		isFileForzen: false,
		/**
		 * Only one selection is allowed
		 * @param {FormData} fd
		 */
		onFormData: function(fd) {
			this.isFileForzen = fd.getNode().IsDriveFileFrozen;
			if(this.isFileForzen){
				fd.m_bAllowSelections = false;
				fd.m_bEditable = false;
			}else{
				fd.m_bSelectOne = true;
				fd.m_bEditable = true;
			}
		},
		/**
		 * @override
		 * Add submit action with Restore as label.
		 */
		addProxyActions: function(/*View*/defView, /*Actions*/defActions) {
			if(this.isFileForzen || !xml.nodeHasRight(this.getNode(), xml.RIGHT_WRITE)){
				defActions.addAction(this.getProxyAction("Cancel", false));
				
			}else{
				this.inherited(arguments);
			}
		},
		/**
		 * @override
		 * Request for restoring the selected version file.
		 */
		process: function() {
			var	req = this.m_action.m_request;
			var versionSelected = this.m_formData.getSelectedNode();
			this.setProgress();
			var postRequest = new PostRequest(req.m_module, req.m_operation);
			postRequest.addParameter("FileId",versionSelected.FileId);
			postRequest.addParameter("Version",versionSelected.Version);
			this.waitForPublish(postRequest.post({}) , true);
		},
		/**
		 * @Override
		 * Display DialogMessage to inform document was successfully shared
		 */
		 postProcessSuccess: function(response) {
			this.inherited(arguments);
			const fileName = this.getNode()["File.File"];
			new MessageDialog({
				buttons: [MessageDialog.BUTTON_OK],
				materialIcon: MessageDialog.ICON_INFO,
				message: locale.resource("DriveFileRestored",[fileName]),
				title: locale.resource("INFORMATION")
			}).show();
		},
	});
});